import * as React from "react";
import { Utilities } from "shared/utilities";
import { ThemeType, UserThemeLocalStorageKey } from "../theme";

export const fetchTheme = () => {
    const themeJson = document.getElementById("theme")?.innerText;
    return ThemeType[themeJson as keyof typeof ThemeType];
}

const useUserTheme = (): [type: ThemeType, setCurrentTheme: (type: IUserTheme) => void] => {

    const [currentThemeFromDb, setCurrentThemeFromDb] = React.useState<IUserTheme>({
        theme: fetchTheme()
    });

    const setCurrentTheme = React.useCallback(async (type: IUserTheme) => {
        try {
            await Utilities.putJsonAndParseResponse(`api/user/config/theme`, { config: type });
            localStorage.removeItem(UserThemeLocalStorageKey);
            setCurrentThemeFromDb(type);
            location.reload();
        } catch (e) {
            if (e.startsWith("Error (403)")) {
                localStorage.setItem(UserThemeLocalStorageKey, type.theme);
                location.reload();
            } else {
                Utilities.toastError(e);
            }
            console.error(e);
        }
    }, []);

    return [currentThemeFromDb.theme, setCurrentTheme];
}

interface IUserTheme {
    theme: ThemeType;
}

export default useUserTheme;